import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* eslint-disable no-multi-assign */
import React from 'react';
import { View } from 'react-native';
import qs from 'qs';
import { Provider } from '../../redux/lib/react-redux';
import ParamContext from '../../redux/lib/react-redux/components/paramContext';
var _Ext$Redux = Ext.Redux,
    defineStore = _Ext$Redux.defineStore,
    usingRedux = _Ext$Redux.usingRedux,
    invariant = _Ext$Redux.invariant;
var uniqueStoreSymbol = 'This_view_has_it\'s_own_store.';
export default {
  title: null,
  history: null,

  /**
   * open 时设置标题
   * @param {string} title
   */
  setTitle: function setTitle(title) {
    this.title = title;
  },
  __storeObj: null,

  /**
   * 在组件的 onDestroy 生命周期销毁特定的 store
   * @param {Number} rootTag native 分配的 rootTag 值
   */
  clearStore: function clearStore(rootTag) {
    if (this.__storeObj[rootTag]) {
      this.__storeObj[rootTag] = null;
      delete this.__storeObj[rootTag];
    }
  },

  /**
   * 获取指定 VC 下的实时 store，如果没有就新建一个
   * @param {Number} rootTag
   * @return store
   */
  getStore: function getStore(rootTag) {
    for (var start = rootTag - 10; start > 0; start -= 10) {
      if (this.__storeObj[start]) {
        return this.__storeObj[start];
      }
    }

    this.__storeObj[rootTag] = defineStore();
    return this.__storeObj[rootTag];
  },
  wrapperRouter: function wrapperRouter(Router) {
    var _this = this;

    var open = Router.open;
    var back = Router.back;

    Router.open = function (viewName) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _split = (viewName || '').split(':'),
          _split2 = _slicedToArray(_split, 2),
          name = _split2[0],
          openParam = _split2[1];

      invariant(!openParam || usingRedux(), '在未配置 \'Ext.defaults.redux.reducer\' 的情况下不能使用 Router.open(\'view:%s\') 的功能。', openParam); // 只有 param 才会被 native 传回来

      if (!options.param) {
        options.param = {};
      }

      if (_this.history) {
        options.history = _this.history;
      }

      switch (openParam) {
        case 'new':
          options.param[uniqueStoreSymbol] = true;
          break;

        default:
          break;
      }

      return open.call(Router, name, options);
    };

    Router.back = function (viewName) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (_this.history) {
        options.history = _this.history;
      }

      return back.call(Router, options);
    };
  },
  shouldShowNavigationBar: function shouldShowNavigationBar(Component) {
    var routerPlugin = Component.routerPlugin;
    var globalNavBarOptions = Ext.defaults.navBar;
    var isShow = globalNavBarOptions.isShow;

    if (routerPlugin && routerPlugin.isShow !== undefined) {
      isShow = routerPlugin.isShow;
    }

    return isShow;
  },
  wrapperView: function wrapperView(className, Component) {
    var _this2 = this;

    // 缓存渲染过的页面
    if (!Component.routerPlugin) {
      Component.routerPlugin = {};
    }

    var renderedElementClass = function renderedElementClass(_ref) {
      var _ref$param = _ref.param,
          param = _ref$param === void 0 ? {} : _ref$param,
          rootTag = _ref.rootTag,
          _ref$isQRCTShareStore = _ref.isQRCTShareStore,
          isQRCTShareStore = _ref$isQRCTShareStore === void 0 ? false : _ref$isQRCTShareStore,
          extraProps = _objectWithoutProperties(_ref, ["param", "rootTag", "isQRCTShareStore"]);

      var hasOwnStore = false;
      _this2.history = extraProps.history; // open 时传进来的 title

      if (_this2.title) {
        Component.routerPlugin.title = _this2.title;
        _this2.title = null;
      }

      var _extraProps$location = extraProps.location,
          location = _extraProps$location === void 0 ? {} : _extraProps$location,
          _extraProps$match = extraProps.match,
          match = _extraProps$match === void 0 ? {} : _extraProps$match;
      var _location$query = location.query,
          query = _location$query === void 0 ? {} : _location$query,
          _location$search = location.search,
          search = _location$search === void 0 ? '' : _location$search;
      var _match$params = match.params,
          matchParams = _match$params === void 0 ? {} : _match$params;
      var searchArr = search.split('?');
      var initParams = Object.assign(param, extraProps, query, qs.parse(searchArr[1] || ''), matchParams);

      if (initParams[uniqueStoreSymbol]) {
        delete initParams[uniqueStoreSymbol];
        hasOwnStore = true;
      }

      if (usingRedux()) {
        var curStore = _this2.__storeObj = _this2.__storeObj ? _this2.__storeObj : defineStore(); // open:new方式打开直接覆盖之前的store

        if (hasOwnStore) {
          curStore = _this2.__storeObj = defineStore();
        } // 渲染 Provider 包裹的 component


        return <Provider store={curStore}>
                        <View style={{
            flexGrow: 1,
            flexShrink: 1
          }}>
                            <ParamContext.Provider value={initParams}>
                                <Component param={initParams} />
                          </ParamContext.Provider>
                      </View>
                  </Provider>;
      }

      return <View style={{
        flexGrow: 1,
        flexShrink: 1
      }}>
                    <ParamContext.Provider value={initParams}>
                        <Component param={initParams} />
                  </ParamContext.Provider>
              </View>;
    };

    return function (props) {
      return renderedElementClass(props);
    };
  }
};